/**
 * Поиск по тикеру без учёта котируемой валюты.
 *
 * Все наши символы кончаются на USDT, поэтому обычный `symbol.includes(q)` на
 * запрос «us» выдавал ВЕСЬ список: приписка совпадала у каждой пары. Ищем по
 * базовой части (то, что до USDT/USDC/USD) — тогда «us» находит US и USUAL, а
 * не тысячу пар, и при этом полный ввод «USUSDT» тоже работает.
 */
const QUOTE_RE = /(USDT|USDC|USD)$/;

/** «USUSDT» → «US». Если после отсечения ничего не осталось — оставляем как есть
 *  (символ вроде «USDTUSDT» или сам «USD» не должен превращаться в пустую строку). */
export function baseSymbol(symbol: string): string {
  const s = (symbol || '').toUpperCase().trim();
  const cut = s.replace(QUOTE_RE, '');
  return cut || s;
}

/** Подходит ли символ под поисковый запрос. Пустой запрос подходит всем. */
export function symbolMatches(symbol: string, query: string): boolean {
  const q = (query || '').toUpperCase().trim();
  if (!q) return true;
  return baseSymbol(symbol).includes(baseSymbol(q));
}
